import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import SimpleLayout from 'src/layouts/simple';
import CompactLayout from 'src/layouts/compact';
// components
import { SplashScreen } from 'src/components/loading-screen';
import CompactNoLoginLayout from 'src/layouts/compact/layout_for_no_login';
import CompactInterviewLayout from 'src/layouts/compact/layout_for_interview';
import InviteRedirectPage from 'src/pages/invite-redirect-page';
import ConfirmationPage from 'src/pages/confirmation';
import PasswordResetRequestPage from 'src/pages/password-reset';
import PasswordResetPage from 'src/pages/reset-password-set';

// ----------------------------------------------------------------------

const Page500 = lazy(() => import('src/pages/500'));
const Page403 = lazy(() => import('src/pages/403'));
const Page404 = lazy(() => import('src/pages/404'));
const FaqsPage = lazy(() => import('src/pages/faqs'));
const AboutPage = lazy(() => import('src/pages/about-us'));
const ContactPage = lazy(() => import('src/pages/contact-us'));
const PricingPage = lazy(() => import('src/pages/pricing'));
const PaymentPage = lazy(() => import('src/pages/payment'));
const ComingSoonPage = lazy(() => import('src/pages/coming-soon'));
const MaintenancePage = lazy(() => import('src/pages/maintenance'));
const InterviewPage = lazy(() => import('src/pages/interview'));
const InterviewPreparePage = lazy(() => import('src/pages/interview_prepare'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <CompactLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </CompactLayout>
    ),
    children: [
      { path: 'coming-soon', element: <ComingSoonPage /> },
      { path: 'invitations/validate', element: <InviteRedirectPage /> },
      { path: 'users/confirmation', element: <ConfirmationPage/> },
      { path: 'users/password_reset', element: <PasswordResetRequestPage/> },
      { path: 'users/password_reset/set', element: <PasswordResetPage/> },
      { path: 'maintenance', element: <MaintenancePage /> },
      { path: '500', element: <Page500 /> },
      { path: '404', element: <Page404 /> },
      { path: '403', element: <Page403 /> },
    ],
  },
  {
    element: (
      <CompactNoLoginLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </CompactNoLoginLayout>
    ),
    children: [
      { path: 'interviews/:job_position_id/room/:room_id', element: <InterviewPage/> },
    ],
  }
  ,
  {
    element: (
      <CompactInterviewLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </CompactInterviewLayout>
    ),
    children: [
      { path: 'interviews/:id/prepare', element: <InterviewPreparePage/> },
    ],
  }
];
